import Vue from "vue";
import VueGtag from "vue-gtag";
import VueCountryCode from "vue-country-code";
import toast from "vue-toastification";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import scrollanimation from "./directives/scrollanimation";
import vuetify from "./plugins/vuetify";
import config from "./config";

// Styles
import "./assets/css/slick.css";
import "./assets/css/slick-theme.css";
import "vue-toastification/dist/index.css";
import "./assets/css/style.css";

Vue.directive("scrollanimation", scrollanimation);
Vue.use(toast);
Vue.use(VueCountryCode);

Vue.use(
  VueGtag,
  {
    enabled: config.environment === "production" ? true : false,
    config: {
      id: "G-TN87H646EC",
      params: {
        send_page_view: false,
      },
    },
  },
  router
);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
